var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.148 14.773a.75.75 0 1 0 1.06 1.06l4.774-4.772 4.773 4.773a.75.75 0 1 0 1.06-1.061L11.042 10l4.773-4.773a.75.75 0 0 0-1.06-1.06L9.982 8.938 5.209 4.166a.75.75 0 0 0-1.061 1.061L8.92 10z",
    clipRule: "evenodd"
  })));
};
export default SvgClose;